import { createFileRoute } from "@tanstack/react-router";
import { MeetCharacters } from "@/lib/lazyPages";
import { charactersIndexSeo } from "@/lib/seo/characters";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/characters/")({
  head: () => seoHead({ ...charactersIndexSeo("/characters"), noindex: true }),
  component: MeetCharacters,
});
